import type { Fallacy } from "./types";
import { createStory } from "./types";

export const equivocation: Fallacy = {
    id: "equivocation",
    name: "Equivocation",
    emoji: "🎭",
    category: "Jebakan Bahasa",
    description:
      "Menggunakan **kata yang sama** dengan **makna berbeda** dalam satu argumen, sehingga kesimpulannya terlihat logis padahal menyesatkan.",
    tldr: "Kata yang sama dipakai dengan arti beda biar argumen keliatan masuk akal.",
    detail:
      "Equivocation terjadi ketika seseorang menggunakan **satu kata dengan dua arti berbeda** dalam argumen yang sama, lalu menarik kesimpulan seolah-olah artinya konsisten. Pelaku **memanfaatkan ambiguitas** untuk membuat argumen yang terdengar logis tapi sebenarnya cacat.\n\nContoh: \"Hukum alam itu pasti berlaku. Hukum pidana juga hukum. Jadi hukum pidana pasti berlaku dengan sempurna.\" — Kata 'hukum' punya **dua arti yang berbeda**.\n\nDi politik dan marketing, equivocation sering digunakan untuk **membuat janji yang terdengar besar tapi sebenarnya kosong**.\n\nCara mengenali: Perhatikan kata-kata kunci. **Apakah maknanya konsisten dari awal sampai akhir?** Kalau berubah di tengah jalan, itu equivocation.",
    story: createStory("Equivocation", "🎭", {
      hook: {
        title: "Kata yang sama, arti beda.",
        body: "Tapi dijadiin satu argumen seolah nyambung. Kamu pernah kena jebakan ini?",
      },
      convo: {
        claim: "Bos bilang kita harus \"transparan\" ke klien soal delay project. Ya udah **kita transparan aja kayak kaca** — keliatan tapi tetep pelindung, gak usah sebut delay-nya.",
        response: "\"Transparan\" di sini artinya jujur, bukan tembus pandang. **Artinya kamu ganti biar enak kamu doang.**",
      },
      reveal: {
        body: "Satu kata dipakai dengan **dua makna berbeda** dalam satu argumen. Kesimpulannya keliatan logis, padahal **artinya udah dibelokkin**.",
      },
      insight: {
        title: "Cara ngeceknya?",
        body: "Gampang — cek kata kuncinya. **Artinya sama dari awal sampai akhir?** Kalau berubah di tengah jalan, kamu lagi dijebak equivocation.",
      },
      engagement: {
        title: "Pernah kena jebakan kata bermakna ganda?",
        body: "Di kerjaan atau pas debat sama temen? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["straw-man", "red-herring", "framing-effect"],
  };
